module.exports = "<select \r\n    [(ngModel)]=\"item\" \r\n    class=\"form-control\" \r\n    [disabled]=\"disabled\">\r\n    <option *ngIf=\"showBlank\" value=\"\"></option>\r\n    <option \r\n        *ngFor=\"let opt of states\" \r\n        value=\"{{opt.stateCode}}\">{{opt.stateCode}} {{opt.name}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/selects/states/states-select.component.html
// module id = ./src/app/shared/selects/states/states-select.component.html
// module chunks = main